





















import Vue, { PropType } from "vue";
import Radio from "./Radio.vue";

export default Vue.extend({
  name: "RadioOption",
  components: {
    Radio
  },
  props: {
    id: { type: String, required: true },
    name: { type: String, required: true },
    value: { type: String as PropType<string | null>, required: true },
    modelValue: { type: String, required: true },
    label: { type: String, required: true },
    description: { type: String, required: true },
    isSelected: { type: Boolean, required: true }
  }
});
